export const DefaultNumItemsPerPages = 50;

export function toTotalPage(
  paginationCount: number,
  itemsPerPage?: number,
): number {
  if (paginationCount === 0) {
    return 1;
  }
  itemsPerPage = itemsPerPage || DefaultNumItemsPerPages;
  return (
    Math.floor(paginationCount / itemsPerPage) +
    (paginationCount % itemsPerPage === 0 ? 0 : 1)
  );
}
